export default {
  setTiposCertificado({ commit }, dadosCertificado) {
    commit('SET_TIPOS_CERTIFICADO', dadosCertificado);
  }
}